import { ChangeDetectionStrategy, Component, input } from "@angular/core";

export type EmptyStateVariant = "primary" | "danger";

@Component({
  selector: "app-empty-state",
  templateUrl: "./empty-state.component.html",
  styleUrls: ["./empty-state.component.scss"],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EmptyStateComponent {
  readonly icon = input.required<string>();
  readonly title = input.required<string>();
  readonly description = input<string>("");
  readonly variant = input<EmptyStateVariant>("primary");
}
